export const SIMULATION_LOCATIONS = [
  'Jebel Ali Port',
  'Sharjah Terminal',
  'Fujairah Bunker',
  'Ajman Terminal',
  'Ruwais Refinery Gate',
  'Hamriyah Free Zone',
  'Dubai Silicon Oasis Depot',
  'Mussafah ICAD',
];

/** Seed rows for first paint — all further orders are injected dynamically */
export const INITIAL_LIVE_ORDERS = [
  {
    id: 'ORD-001',
    orderRef: 'DO-2026-041 — Fuel Delivery to Ajman Terminal',
    volume: '50,000 Liters Gasoil',
    status: 'Unassigned',
    vendorId: '',
    driverId: '',
  },
  {
    id: 'ORD-002',
    orderRef: 'DO-2026-042 — Jet Fuel Drop to Dubai South',
    volume: '38,000 Liters Jet A-1',
    status: 'Unassigned',
    vendorId: '',
    driverId: '',
  },
  {
    id: 'ORD-003',
    orderRef: 'DO-2026-043 — LPG Bulk to Sharjah Industrial',
    volume: '22,000 Liters LPG',
    status: 'Dispatched',
    vendorId: 'VND-442',
    driverId: 'DRV-002',
  },
  {
    id: 'ORD-004',
    orderRef: 'DO-2026-044 — Diesel ULSD to Fujairah Port',
    volume: '45,000 Liters Diesel EN590',
    status: 'Delivered',
    vendorId: 'VND-786',
    driverId: 'DRV-001',
  },
];

export function getNextOrderSequence(existingOrders = []) {
  const fromRefs = existingOrders
    .map((o) => {
      const match = o.orderRef?.match(/DO-2026-(\d+)/);
      return match ? Number(match[1]) : 0;
    })
    .filter(Boolean);
  const peak = fromRefs.length ? Math.max(...fromRefs) : 44;
  return peak + 1;
}

export function formatVolumeLiters(liters) {
  const n = Math.max(0, Math.round(Number(liters) || 0));
  return `${n.toLocaleString('en-AE')} Liters Gasoil`;
}

/**
 * Build a new unassigned dispatch row for the live grid.
 * @param {{ location: string, liters: number, sequence: number }} params
 */
export function buildLiveOrder({ location, liters, sequence }) {
  const seq = String(sequence).padStart(3, '0');
  const cleanLocation = location.trim() || 'Unspecified Terminal';

  return {
    id: `ORD-${Date.now()}-${sequence}`,
    orderRef: `DO-2026-${seq} — Fuel Delivery to ${cleanLocation}`,
    volume: formatVolumeLiters(liters),
    status: 'Unassigned',
    vendorId: '',
    driverId: '',
  };
}

export function pickRandomSimulationLocation() {
  return SIMULATION_LOCATIONS[Math.floor(Math.random() * SIMULATION_LOCATIONS.length)];
}

export function pickRandomSimulationVolume() {
  const min = 20000;
  const max = 80000;
  const step = 1000;
  const steps = (max - min) / step;
  return min + Math.floor(Math.random() * (steps + 1)) * step;
}
